
import React, {useContext, useEffect, useState} from 'react'
import { SpinnerComponent } from 'react-element-spinner'
import {
	Card,
	CardBody,
	CardFooter,
	CardHeader,
	CardText,
	Col,
	Container,
	Label,
	Row
} from 'reactstrap'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import VehiclesService from '../../../../services/VehiclesService'
import { SessionContext } from '../../../../contexts/SessionProvider'
import SiteService from '../../../../services/SiteService'
import { AuctionsContext } from '../../../../contexts/AuctionsProvider'
import PageTitleContextMenu from '../../../../components/PageTitles/PageTitleContextMenu'
import AuctionsNavBar from '../../../../components/Navbars/AuctionsNavBar'

const AuctionOptions = ({ embedded = false, onRequestClose, onSelectDetailTab }) =>
{
	const { t } = useTranslation()
	const [isBusy, setIsBusy] = React.useState(false)
	const auctionsContext = useContext(AuctionsContext)
	const sessionContext = useContext(SessionContext)
	const [vehicleBuild, setVehicleBuild] = useState({ vehicleBuildId: null, vehicleId: null, modelYear: null, make: '', model: '', trim: '', modelCode: '', optionCodes: '', options: '' })
	const navigate = useNavigate()
	
	useEffect(() =>
	{
		initializeComponent()
	}, [])
	
	const initializeComponent = () =>
	{
		retrieveBuildData()
	}
	
	const retrieveBuildData = () =>
	{
		setIsBusy(true)
		VehiclesService
			.getBuildData(auctionsContext.auction.auctionVehicle.vehicleId, sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsBusy(false)
				sessionContext.updateSession(result.data.loginSession)
				
				if (result.data.actionResult)
				{
					setVehicleBuild(result.data.actionResult)
				}
			})
			.catch((error) =>
			{
				setIsBusy(false)
				SiteService.displayApiError(error)
			})
	}
	
	const handleGoBack = () =>
	{
		if (embedded)
		{
			if (typeof onRequestClose === 'function') onRequestClose()
			return
		}
		navigate('/secure/auctions-listing')
	}
	
	return (
		<div style={{
			zIndex: 500
		}}>
			<SpinnerComponent
				loading={ isBusy }
				position="global"
				color="#3578e5"
				secondaryColor="#f3f3f3"
				backgroundColor="#d3d3d3"
				spinnerType="circle-dots"
			/>
			{
				!embedded &&
				<PageTitleContextMenu
					heading={ t('Auctions.Options.Title') }
					subheading={ auctionsContext.auction.auctionVehicle.vehicle.year + ' ' +
						auctionsContext.auction.auctionVehicle.vehicle.make + ' ' +
						auctionsContext.auction.auctionVehicle.vehicle.model + ' / ' +
						auctionsContext.auction.auctionVehicle.vehicle.trim + ' / ' +
						auctionsContext.auction.auctionVehicle.vehicle.serialNumber
					}
					icon="pe-7s-ticket icon-gradient bg-premium-dark"
					headerOptions={ { showBack: true, backCommand: () => { handleGoBack() }, showReload: false, reloadCommand: null } }
				/>
			}
			<Container className={ embedded ? "" : "mt--6" } fluid>
				<Row>
					<div className="col">
						<Card>
							<CardHeader style={{padding: '0.5rem 0.75rem'}}>
								<AuctionsNavBar
									parentComponent={'auction-options'}
									onSelect={ embedded ? onSelectDetailTab : undefined }
								/>
							</CardHeader>
							<CardBody>
								{
									vehicleBuild !== null && vehicleBuild !== undefined &&
									<>
										<Row>
											<Col md={4}>
												<Label style={{ borderBottomWidth: '1px', borderBottomColor: 'gray', borderBottomStyle: 'solid' }}>
													{ t('Vehicles.Detail.Model_Year') }
												</Label>
												<CardText className="mb-4" style={{ fontSize: 'smaller' }}>{ vehicleBuild.modelYear }</CardText>
											</Col>
											<Col md={4}>
												<Label style={{ borderBottomWidth: '1px', borderBottomColor: 'gray', borderBottomStyle: 'solid' }}>
													{ t('Vehicles.Detail.Make') }
												</Label>
												<CardText className="mb-4" style={{ fontSize: 'smaller' }}>{ vehicleBuild.make }</CardText>
											</Col>
											<Col md={4}>
												<Label style={{ borderBottomWidth: '1px', borderBottomColor: 'gray', borderBottomStyle: 'solid' }}>
													{ t('Vehicles.Detail.Model') }
												</Label>
												<CardText className="mb-4" style={{ fontSize: 'smaller' }}>{ vehicleBuild.model }</CardText>
											</Col>
											<Col md={4}>
												<Label style={{ borderBottomWidth: '1px', borderBottomColor: 'gray', borderBottomStyle: 'solid' }}>
													{ t('Vehicles.Detail.Trim') }
												</Label>
												<CardText className="mb-4" style={{ fontSize: 'smaller' }}>{ vehicleBuild.trim }</CardText>
											</Col>
											<Col md={4}>
												<Label style={{ borderBottomWidth: '1px', borderBottomColor: 'gray', borderBottomStyle: 'solid' }}>
													{ t('Vehicles.Detail.Model_Code') }
												</Label>
												<CardText className="mb-4" style={{ fontSize: 'smaller' }}>{ vehicleBuild.modelCode }</CardText>
											</Col>
											<Col md={4}>
												<Label style={{ borderBottomWidth: '1px', borderBottomColor: 'gray', borderBottomStyle: 'solid' }}>
													{ t('Vehicles.Detail.Option_Codes') }
												</Label>
												<CardText className="mb-4" style={{ fontSize: 'smaller' }}>{ vehicleBuild.optionCodes }</CardText>
											</Col>
										</Row>
										<Row>
											<Col md={12}>
												<Label style={{ borderBottomWidth: '1px', borderBottomColor: 'gray', borderBottomStyle: 'solid' }}>
													{ t('Vehicles.Detail.Options') }
												</Label>
												<CardText className="mb-4" style={{fontSize: 'smaller'}}>{vehicleBuild.options}</CardText>
											</Col>
										</Row>
									</>
								}
							</CardBody>
							<CardFooter></CardFooter>
						</Card>
					</div>
				</Row>
			</Container>
		</div>
	)
}

export default AuctionOptions
